const openInNewTab = (html: string) => {
	const blob = new Blob([html], { type: "text/html" });
	const url = URL.createObjectURL(blob);
	window.open(url, "_blank");
	setTimeout(() => URL.revokeObjectURL(url), 2000);
};

export default openInNewTab;
